export default {
  heroTitle1: 'Solcelleaftale',
  heroTitle2: 'Uden leverandørgebyr',
  heroSubtitle: 'Sælg din overskudsproduktion via elbørsen uden leverandørgebyr.',
  heroNote: 'Ingen leverandørgebyrer fra enkel. Du betaler kun lovpligtige omkostninger og transportgebyrer.',
  signUpNow: 'Tilmeld dig nu',

  // Unique banner
  uniqueBadge: '0 KR. LEVERANDØRGEBYR',
  uniqueBannerTitle: 'Danmarks eneste solcelleaftale uden leverandørgebyr',
  uniqueBannerSubtitle: 'Alle andre leverandører i Danmark opkræver månedlige gebyrer – vi tager 0 kr. i leverandørgebyr',

  // Free banner
  freeBannerTitle: '0 kr. i månedligt leverandørgebyr',
  freeBannerSubtitle: 'Markedspris for din produktion – uden leverandørgebyr',
  freeBannerNote: '0 kr. i leverandørgebyr hos enkel',

  // Why choose
  whyChooseTitle: 'Hvorfor vælge enkel som din produktionsleverandør?',
  whyChooseSubtitle: 'Vi er Danmarks eneste leverandør der ikke opkræver leverandørgebyrer på solcelleaftaler.',
  benefit1Title: 'Den ENESTE uden leverandørgebyr',
  benefit1Desc: 'Hos enkel er leverandørgebyret 0 kr.',
  benefit2Title: 'Markedspris minus kun lovpligtige omkostninger',
  benefit2Desc: 'Du betaler kun lovpligtige omkostninger og transportgebyrer fra netselskabet og Energinet – ingen leverandørgebyrer oveni.',
  benefit3Title: 'Fuld gennemsigtighed',
  benefit3Desc: 'Vi tilføjer ingen provision eller tillæg – du får markedsprisen minus kun lovpligtige omkostninger og transportgebyrer.',
  cancellationTerms: 'Opsigelse: Løbende måned + 1 måned',

  // How it works
  howItWorksTitle: 'Kom i gang på 3 enkle trin',
  howItWorksSubtitle: 'Vi håndterer alt det praktiske for dig',
  step1Title: 'Vælg en elaftale hos enkel',
  step1Text: 'Markér at du har solceller, så arbejder vi på at få dig flyttet over til produktionsaftalen.',
  step2Title: 'Registrering af dit anlæg',
  step2Text: 'Dit anlæg skal være registreret hos netselskabet.',
  step3Title: 'Automatisk afregning',
  step3Text: 'Din overskudsstrøm afregnes automatisk til markedspris minus lovpligtige omkostninger og transportgebyrer – ingen leverandørgebyrer.',
  chooseElAftale: 'Vælg din el-aftale',

  // Benefits
  benefitsTitle: 'Hvad får du med?',
  freeProductionAgreement: 'Produktionsaftale uden leverandørgebyr',
  noMonthlyFees: 'Ingen leverandørgebyrer',
  noHiddenFees: 'Ingen leverandørgebyrer overhovedet',
  fullTransparency: 'Fuld gennemsigtighed i priser',
  autoSettlement: 'Automatisk afregning via elbørsen',
  fullMarketPrice: 'Markedspris minus lovpligtige omkostninger',
  flexibleCancellation: 'Fleksibel opsigelse',
  cancellationNotice: 'Opsigelse',
  cancellationTerms: 'Løbende måned + 1 måned',

  // FAQ
  faqTitle: 'Ofte stillede spørgsmål',
  faq1Q: 'Hvad koster solcelleaftalen?',
  faq1A: 'Solcelleaftalen koster 0 kr. i leverandørgebyr – du betaler kun lovpligtige omkostninger og transportgebyrer til netselskabet og Energinet.',
  faq2Q: 'Hvordan afregnes min overskudsstrøm?',
  faq2A: 'Din overskudsproduktion afregnes automatisk via elbørsen efter markedspris minus lovpligtige omkostninger og transportgebyrer – ingen leverandørgebyrer.',
  faq3Q: 'Kan jeg kombinere solceller med en elbil?',
  faq3A: 'Ja, men der findes ingen automatisk integration mellem solcelleproduktion og opladning endnu.',
  faq4Q: 'Hvordan kommer jeg i gang?',
  faq4A: 'Vælg en elaftale hos enkel og markér, at du har solceller. Vi håndterer resten.',
  faq5Q: 'Hvad er opsigelsesperioden?',
  faq5A: 'Opsigelsesperioden er løbende måned + 1 måned. Dette er markedsstandard for produktionsaftaler.',
  faq6Q: 'Hvad hvis jeg ikke har solceller endnu?',
  faq6A: 'Du kan oprette elaftalen nu og tilføje solcelleaftalen senere.',
  faq7Q: 'Hvad betyder aftagepligten for min solcelleaftale?',
  faq7A: 'Afregningsgruppen er ikke længere afgørende – det afgørende er, om dit anlæg er omfattet af aftagepligten, hvor Energinet (via Vindstød) automatisk opkøber din overskudsstrøm. Er du omfattet, skal du først fravælge dit pristillæg hos Energistyrelsen via Borger.dk (MitID), før vi kan overtage. Det tager ofte op til 3 måneder. Er du ikke omfattet, kan vi overtage uanset afregningsgruppe.',

  // Cross-sell
  crossSellTitle: 'Se vores andre produkter',
  crossSellSubtitle: 'Kombiner solceller med el-aftale og ladeboks',

  // Final CTA
  finalCtaTitle: 'Klar til at komme i gang?',
  finalCtaSubtitle: 'Vælg en elaftale og tilføj vores solcelleaftale uden leverandørgebyrer',
  elPlusSolar: 'El + Solcelle',
  onlySolarLink: 'Vil du kun have solcelleaftale? Klik her',
};